import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/connect";

const PesticideUse = ({ onPesticideUseSelected }) => {
  const [selectedPesticideUse, setSelectedPesticideUse] = useState(null);
  const [variations, setVariations] = useState([]);
  const { prodcode } = useParams();

  const getAllProductVariations = async () => {
    try {
      const response = await fetch(
        `https://ghmarkets.net/test/ghmarketconnect/?ghw=productservices&svg=fashionvariations&prcode=${prodcode}`
      );
      const json = await response.json();
      const firstResult = json["results"][0];
      if (firstResult && firstResult.pesticideuse) {
        const pesticideUseObject = firstResult.pesticideuse;
        if (pesticideUseObject.trim() !== "") {
          setVariations(pesticideUseObject.split(","));
        }
      }
    } catch (error) {
      // Handle error here
    }
  };

  useEffect(() => {
    getAllProductVariations();
  }, [prodcode]);

  const handlePesticideUseClick = (pesticideuse) => {
    setSelectedPesticideUse(pesticideuse);
    onPesticideUseSelected(pesticideuse);
  };

  return variations.length > 0 ? (
    <div
      className="sizes-container"
      style={{ display: "flex", flexDirection: "row" }}
    >
      <span
        style={{
          fontSize: "",
          fontWeight: "bold",
          color: "black",
          marginTop: "12px",
        }}
      >
        Pesticide Use:
      </span>
      <div className="sizes">
        {variations.map((variation, i) => (
          <div
            key={i}
            className={`size ${selectedPesticideUse === variation ? "selected" : ""}`}
            onClick={() => handlePesticideUseClick(variation)}
          >
            {variation}
          </div>
        ))}
      </div>
    </div>
  ) : (
    ""
  );
};

export default PesticideUse;
